import { Component, OnInit, Input, HostListener } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';
import { URLSearchParams } from '@angular/http';

import { compareElements } from 'app/shared/validators/generic-validators';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';
import { unsavedFormCheck } from 'app/shared/validators/generic-validators';

import { TaskDefinition } from 'app/shared/models/task-definition.model';

import { ProcessService } from './../process.service';

@Component({
  templateUrl: './task-editor.component.html',
  providers: [ProcessService],
})

/**
 * Dialog component to update task definition description through editor.
 */
export class TaskEditorComponent implements OnInit {
  taskEditorForm: FormGroup;
  argTaskDetailsData: TaskDefinition;
  taskKey: string;
  taskName: string;
  taskDescription: string;

  constructor(private formBuilder: FormBuilder,
    public dialogRef: MdDialogRef<any>,
    private processService: ProcessService,
    private snackBarService: SnackBarService,
    private trackingService: TrackingService) {
  }

  ngOnInit(): void {
    this.buildForm();
    this.updateTaskDetailsDataForm();
  }

  // @todo This function might get updated once REST is available.
  buildForm() {
    this.taskEditorForm = this.formBuilder.group({
      taskGuideText: [{ value: "" }],
    });
  }

  // Method to update task values and display in the dialog.
  updateTaskDetailsDataForm(): void {
    if (this.argTaskDetailsData) {
      this.taskKey = this.argTaskDetailsData.key;
      this.taskName = this.argTaskDetailsData.name;
      this.taskDescription = this.argTaskDetailsData.description;
      this.taskEditorForm.patchValue({
        taskGuideText: this.argTaskDetailsData.guide,
      });
    }
  }

  // Method to submit the changes for Task Guide text.
  onSubmit({ value, valid }) {
    this.taskEditorForm.disable();
    const taskModel = new TaskDefinition();
    taskModel.key = this.taskKey;
    taskModel.guide = value.taskGuideText;
    taskModel.name = this.taskName;
    taskModel.description = this.taskDescription;
    this.processService.updateTaskGuideText(taskModel)
      .subscribe(response => {
        if (response.flagResult) {
          this.dialogRef.close(taskModel);
        }
        this.trackingService
          .emitEvent(
          TrackingConstants.TASK_GUIDE_TEXT_UPDATE,
          TrackingConstants.PERFORM_TASK_GUIDE_TEXT_UPDATE,
          TrackingConstants.SUCCESS, 1);
        this.callSnackBarService(response);
      }, err => {
          this.trackingService
            .emitEvent(
            TrackingConstants.TASK_GUIDE_TEXT_UPDATE,
            TrackingConstants.PERFORM_TASK_GUIDE_TEXT_UPDATE,
            TrackingConstants.FAILURE, 0);
          this.callSnackBarService(err);
      }
    );
  }

  callSnackBarService(response: any) {
    this.snackBarService
      .showStatus(response,
      MessageService.TASK_GUIDE_TEXT_UPDATE_SUCCESS,
      MessageService.TASK_GUIDE_TEXT_UPDATE_FAILURE);
  }

  @HostListener('keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    unsavedFormCheck(event, this.dialogRef, this.taskEditorForm);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/processes/taskeditor/task-editor.component.ts